import template from "./hb-me.mjs";
import { render } from "lit-html";
import { User } from "firebase/auth";
import { Me } from "../../managers/Me";
import {
    getName,
    getAuraColor,
    getKiitosAuraColor,
    getKiittiAuraColor,
    getKiitosAuraSize,
    getKiittiAuraSize
} from "../global";
import { HeartBank } from "../../managers/HeartBank";

const avatar = new URL("../../public/avatar.webp", import.meta.url).href;

//TODO: later make avatar clickable opens user profile?
export class HbMe extends HTMLElement {
    private heartbank = new HeartBank();
    private me = new Me();

    private photo: HTMLImageElement;
    private name: HTMLSpanElement;

    // BUG: cannot render in constructor when using document.createElement
    constructor() {
        super();
        render(template, this);

        this.photo = this.querySelector("#hb-me-photo")!;
        this.name = this.querySelector("#hb-me-name")!;
    }

    async connectedCallback() {
        if (this.key) {
            if (this.uid) {
                await this.renderProfile(this.uid);
            } else {
                const uid = await this.me.getUserId(this.key);
                await this.renderProfile(uid, this.key);
            }
            if (
                this.hidename ||
                (await this.me.getFromAddressType2(
                    this.key,
                    this.heartbank.user?.uid || null
                ))
            )
                this.name.textContent = await this.me.getAddressName(
                    this.key,
                    this.uid
                );
        } else if (this.uid) {
            await this.renderProfile(this.uid);
        } else {
            await this.renderProfile(null);
        }

        // if (this.key) {
        //     const uid = await this.me.getUserId(this.key);
        //     if (uid) {
        //         this.renderProfile(uid);
        //     } else {
        //         if (this.uid) {
        //             const profile = await this.me.getUserProfile(this.uid);
        //             this.name.textContent = "Anonymous";
        //             this.photo.style.borderColor = profile.phoneNumber
        //                 ? "red"
        //                 : "silver"; // later add in gold and platinum
        //             this.photo.style.backgroundColor = "pink"; // aura
        //             this.photo.src = avatar;
        //         } else {
        //             this.render(this.heartbank.user);
        //         }
        //     }
        // }

        // this.heartbank.addAuthStateListener((user) => {
        //     this.render(user);
        // });
    }

    // attribute names are case-insensitive in HTML
    static get observedAttributes() {
        return [
            "uid", // anonymous
            "key", // heartkey or trustkey or ""
            "hidename" // boolean: show user name or hold name
        ];
    }

    get uid(): string {
        return this.getAttribute("uid") ?? "";
    }

    set uid(value: string) {
        this.setAttribute("uid", value);
    }

    get key(): string {
        return this.getAttribute("key") ?? "";
    }

    set key(value: string) {
        this.setAttribute("key", value);
    }

    get hidename(): boolean {
        return this.hasAttribute("hidename");
    }

    set hidename(value: boolean) {
        if (value) this.setAttribute("hidename", "");
        else this.removeAttribute("hidename");
    }

    async attributeChangedCallback(
        name: string,
        oldValue: string | null,
        newValue: string | null
    ) {
        switch (name) {
            case "key":
                // if (newValue) {
                //     const uid = await this.me.getUserId(newValue);
                //     this.renderProfile(uid);
                // } else {
                //     this.render(this.heartbank.user);
                // }
                break;
            case "uid":
                //console.log(this.key); // always empty
                break;
            case "hidename":
                //this.name.classList.toggle("hidden", this.hidename);
                break;
        }
    }

    // not used?
    show() {
        this.classList.remove("hidden");
    }

    // not used?
    hide() {
        this.classList.add("hidden");
    }

    // not used?
    public async render(user: User | null) {
        if (user) {
            const profile = await this.me.getUserProfile(user.uid);
            this.name.textContent = getName();
            this.photo.style.borderColor = getKiitosAuraColor(
                profile.kiitosFrequency || 0
            );
            this.photo.style.borderWidth = getKiitosAuraSize(
                profile.kiitosFrequency || 0
            );
            this.photo.style.boxShadow = `0 0 0 ${getKiittiAuraSize(profile.kiittiAmplitude || 0)} ${getKiittiAuraColor(profile.kiittiFrequency || 0)}`;
            // this.photo.classList.add(
            //     getKiittiAuraColor(profile.kiittiFrequency || 0),
            //     getKiittiAuraSize(profile.kiittiAmplitude || 0)
            // );
            this.photo.style.background = getAuraColor(
                profile.kiitosFrequency || 0,
                profile.kiittiFrequency || 0
            );
            this.photo.src = user.photoURL || avatar;
        } else this.renderProfile(null);
    }

    private async renderProfile(uid: string | null, key: string | null = null) {
        if (uid) {
            const profile = await this.me.getUserProfile(uid);
            this.name.textContent = getName(profile); // need to be short to be used in from TODO: refactor later in v2
            // this.name.textContent =
            //     profile.displayName ||
            //     (profile.username ? "@" + profile.username : null) ||
            //     (isHeartkey
            //         ? profile.heartkey?.truncate(5, 5)
            //         : profile.trustkey?.truncate(5, 5)) ||
            //     "No Name";

            this.photo.style.borderColor = getKiitosAuraColor(
                profile.kiitosFrequency || 0
            );
            this.photo.style.borderWidth = getKiitosAuraSize(
                profile.kiitosFrequency || 0
            );
            this.photo.style.boxShadow = `0 0 0 ${getKiittiAuraSize(profile.kiittiAmplitude || 0)} ${getKiittiAuraColor(profile.kiittiFrequency || 0)}`;
            // this.photo.classList.add(
            //     getKiittiAuraColor(profile.kiittiFrequency || 0),
            //     getKiittiAuraSize(profile.kiittiAmplitude || 0)
            // );
            this.photo.style.background = getAuraColor(
                profile.kiitosFrequency || 0,
                profile.kiittiFrequency || 0
            );
            this.photo.src = profile.photoURL || avatar;
        } else {
            this.name.textContent = key?.truncate() || "You"; // weird bug: can't do .truncate(5, 5)
            this.photo.style.borderColor = "transparent";
            this.photo.style.backgroundColor = "transparent";
            this.photo.src = avatar;
        }
    }
}
